
import React from "react";
import useFetchCategories from "../../lib/hooks/use-fetch-categories";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import { Link, useParams } from "react-router-dom";
import useFetchProductsDetail from "../../lib/hooks/use-fetch-products-detail";
import { ProductDetails } from "../../ui/product-details";

export default  function ProductsDetail() {
    
  let params: any = useParams();
  const {products,loading} = useFetchProductsDetail({ slug: params.url }); 

  console.log("ProductsDetail::",products);
  const {categories} = useFetchCategories(); 
  const user = getCurrentUser();
  return (
    <React.Fragment>

        <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Dashboard</Link>
          <Link to="/admin/products">Products</Link>
          <span>{products?.title}</span>
        </div>
      </div>
      <ProductDetails product={products}   loading={loading} />
    </React.Fragment>
  );
}
